import { setTimeout } from "timers";

jQuery(document).ready(function($){
    var executeAnimate = false;
    var intViewportHeight;
    var intViewportWidth;

    if($('#lista-provas').length > 0 ) {
        var owl = $('.owl-carousel').owlCarousel({
            loop:false,
            stagePadding: 20,
            responsiveClass:true,
            responsive:{
                0:{
                    items:3,
                    nav:false
                },
                768: {
                    items:4,
                }
            },
    
        });
    
        var destacaItemCentral = function(){
            $('.slider-provas .destaque').removeClass('destaque');
            $(".slider-provas.active .owl-carousel .owl-item.active").filter(function(index, element){
                return index == 1;
            }).addClass("destaque");
        }
        
        destacaItemCentral(); 
        
        owl.on('translated.owl.carousel', function(event) {
            destacaItemCentral();
        });
        
        
        $(window).load(function(){
            destacaItemCentral();
        });
    }

    if($('#lista-questoes').length > 0){
        $('#btn-ver-mais').click(function(){
            $('#lista-questoes').removeClass('reduzido');
        });
    }

    $('#close').click(function(){
        $('.atentionMenu').attr('style', 'display: none');
        $('.headerLogo').attr('style', 'margin: 70px 0 0');
    });

    var list = $('.menuAnos__links');
    var listItems = list.children('li');
    list.append(listItems.get().reverse());

    $('#arrowDown').click(function(){
        $('.menuAnos__links').toggle();
        $('#arrowDown i').toggleClass('rotate');
    }); 

    // Set Up da Página inicial = FULLDAY 
    if($('#app').hasClass('fullDay')){
        // Exclui o aviso do Header
        $('.atentionMenu').attr('style', 'display: block'); 
        // Remontando o HEADER  
        $('.header-home').removeClass('reduzido');
        $('.headerLogo > img').attr('style', 'display: block');
        $('.headerLogo > a').attr('style', 'display: none');
        $('.headerIcons').attr('style', 'display: block');
        $('.headerAcelera').attr('style', 'display: block'); 

        // Provas Home setup
        $('#switch-dias-provas .switch-dias.home').removeClass('reduzido');
        $('#switch-dias-provas').addClass('upper-home');
        $('#lista-provas').attr('style', 'display: none');
        
        // BTN DIA setup
        let dia = $('.btn-dia').data('dia');
        $('.btn-dia').removeClass('active');
        $('.col-xs-6').removeClass('active');
        $('.col-xs-6').removeClass('noDay');

        $('.slider-provas').removeClass('active');

        $('#videos-comentarios-gerais').attr('style', 'display: none');

        $('.col-xs-6').not('.active').css("display", "block");

        $('.slider-provas').addClass('destaque');
    };

    if( $('#videos-comentarios-gerais').length > 0 ) {
        $('.item-video-comentario').each(function(){
            if( $(this).find('.embed-video iframe').length > 0 ){
                var url = $(this).find('.embed-video iframe')[0].src;
                if(url.indexOf('youtube') >= 0){
                    var url = url.replace('&autoplay=1', '');
                    $(this).find('.embed-video iframe')[0].src = url
                }
            }
        });
    }

    if( $('#detalhe-questao').length > 0 ) {
        $('#thumb-video').click(function(){
            $(this).addClass('hidden');
            $(this).closest('#video-questao').find('iframe')[0].src += "&autoplay=1";
            return false;
        })
    }


    if( $('#aviso').length > 0 ) {
        // Update the count down every 1 second
        var x = setInterval(function() {
                
            // Get todays date and time
            var now = new Date().getTime();
                
            // Find the distance between now an the count down date
            var distance = countDownDate - now;

            // Time calculations for days, hours, minutes and seconds
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);

            if (seconds < 10){
                seconds = '0' + seconds;
            }
            
            document.getElementById("timer").innerHTML = minutes + ":" + seconds + "";

            // If the count down is finished, write some text 
            if (distance < 0 ) {
                document.getElementById("aviso").classList.add("hidden");
                document.querySelector('body').classList.remove('has_aviso');
                clearInterval(x);
            }
            if (distance > 0 ) {
                document.getElementById("aviso").classList.remove("hidden");
                document.querySelector('body').classList.add('has_aviso');
            }
        }, 1000);
    }
})